"use strict"

const headerSlider = new Swiper('#header-slider', {
    speed: 1000,
    spaceBetween: 24,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 5000,
    },
});

const casesSlider = new Swiper('#cases-slider', {
    slidesPerView: 'auto',
    freeMode: true,
    speed: 1000,
    loop: true,
    spaceBetween: 24,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '#cases-slide-next',
        prevEl: '#cases-slide-prev',
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
});

const insSlider = new Swiper('#ins-slider', {
    slidesPerView: 'auto',
    freeMode: true,
    speed: 1000,
    //loop: true,
    spaceBetween: 24,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '#ins-slide-next',
        prevEl: '#ins-slide-prev',
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
});

//получаем ширину container
function updateContainerWidth() {
    const container = document.querySelector('.container');
    const width = container.offsetWidth;

    document.documentElement.style.setProperty(
        '--container-width',
        width + 'px'
    );
}

updateContainerWidth();
window.addEventListener('resize', updateContainerWidth);

const techSlider = new Swiper('#technology-slider', {
    slidesPerView: 1,
    speed: 800,
    spaceBetween: 24,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    observer: true,
    observeSlideChildren: true,
    observeParents: true,
    breakpoints: {
        // when window width is >= 320px
        1980: {
            slidesPerView: 4,
        },
        1300: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 2,
        },
        655: {
            slidesPerView: 2,
        },
    },

    navigation: {
        nextEl: '#tech-slide-next',
        prevEl: '#tech-slide-prev',
    },
    pagination: {
        el: "#tech-slide-pagination",
        type: "progressbar",
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    on: {
        init: setProgressBarWidth,
        slideChange: setProgressBarWidth,
    },
});

function setProgressBarWidth() {
  setTimeout(() => {
    const activeSlide = this.slides[this.activeIndex];
    const slideWidth = activeSlide.offsetWidth;

    const progressBar = document.querySelector('.page-about .technology .nav-slider');

    if (progressBar) {
      progressBar.style.width = `${slideWidth}px`;
    }
  }, 800);
}


if (typeof gsap !== 'undefined') {
    //paralax
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1200px)", () => {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother)
        ScrollSmoother.create({
            wrapper: '.gswrap',
            content: '.gs-content',
        });

        const sections = gsap.utils.toArray("section");

        sections.forEach((section, i) => {
            if (i === sections.length - 1) return;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "40% top",
                    end: "+=100%",
                    //markers: true,
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                }
            });

            // Первая половина — лёгкое уменьшение
            tl.to(section, {
                scale: 1,
                ease: "none",
                duration: 0.5
            });

            // Вторая половина — исчезновение + lift вверх
            tl.to(section, {
                y: -200,            // ← lift вверх (можно регулировать)
                scale: 0.98,
                opacity: 0,
                filter: "blur(2px)",
                ease: "none",
                duration: 0.5
            });

            ScrollTrigger.refresh();
        });
    });

    //scroll
    gsap.registerPlugin(ScrollToPlugin);

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        const href = link.getAttribute("href");

        // пропускаем пустые якоря типа "#"
        if (href.length > 1) {
            link.addEventListener("click", e => {
                const target = document.querySelector(href);

                // если элемент реально существует
                if (target) {
                    e.preventDefault();

                    gsap.to(window, {
                        duration: 1,
                        scrollTo: {
                            y: target,
                        },
                        ease: "none"
                    });
                }
            });
        }
    });

}

//cases classes toggle
const items = () => document.querySelectorAll('.cases-list .case-item');

document.addEventListener('click', (e) => {
    const item = e.target.closest('.cases-list .case-item');
    const active = document.querySelector('.cases-list .case-item.more-active');

    if (item) {
        // если клик по уже активному — сброс
        if (item === active) {
            items().forEach(el => {
                el.classList.remove('opacity', 'more-active');
            });
            return;
        }

        // иначе активируем
        items().forEach(el => {
            el.classList.add('opacity');
            el.classList.remove('more-active');
        });

        item.classList.remove('opacity');
        item.classList.add('more-active');
        return;
    }

    // клик вне — сброс
    items().forEach(el => {
        el.classList.remove('opacity', 'more-active');
    });
});

//Выбор доктора при клике на кнопку
const buttons = document.querySelectorAll(".doctor-appointment");

buttons.forEach(button => {
    button.addEventListener("click", () => {
        const value = button.dataset.docid;
        const option = document.querySelector(`.doctors-select option[value="${value}"]`);

        if (option) option.selected = true;
    });
});

//Выборка доктора при смене select для отправки
document.querySelectorAll('.wpcf7-form').forEach(form => {
    const select = form.querySelector('select[name="doctor"]');
    const hiddenInput = form.querySelector('input[name="single_doc"]');

    if (!select || !hiddenInput) return;

    select.addEventListener('change', function () {
        const selectedOption = this.selectedOptions[0];
        hiddenInput.value = selectedOption.textContent.trim();
    });
});

const inputButton = document.querySelector('.right-column .wpcf7-form input[type="submit"]');

if (inputButton) {
    inputButton.value = 'Запис на консультацію';
}

//reviews
setTimeout(() => {
    const nextButton = document.getElementById('rv-slide-next');
    if (nextButton) {
        nextButton.addEventListener('click', () => {
            const tiNext = document.querySelector('.ti-next');
            if (tiNext) tiNext.click();
        });
    }

    const prevButton = document.getElementById('rv-slide-prev');
    if (prevButton) {
        prevButton.addEventListener('click', () => {
            const tiPrev = document.querySelector('.ti-prev');
            if (tiPrev) tiPrev.click();
        });
    }
}, 500);

//сокращение фио
function convertNameFirstToSurnameInitials(fullName) {
    const parts = fullName.trim().split(/\s+/);

    // Проверяем, что в строке ровно 3 части (Имя, Отчество, Фамилия)
    if (parts.length !== 3) {
        return fullName; // Возвращаем оригинал, если формат не соответствует
    }

    const name = parts[0];      // Имя
    const patronymic = parts[1]; // Отчество
    const surname = parts[2];    // Фамилия

    // Получаем инициалы: первая буква + точка
    const nameInitial = name[0] + '.';
    const patronymicInitial = patronymic[0] + '.';

    // Формируем результат: «Фамилия И. И.»
    return `${surname} ${nameInitial} ${patronymicInitial}`;
}

// Функция для применения преобразования ко всем опциям select
function applyToAllOptions(selectID, transformFunction) {
    const select = document.querySelector(selectID);

    if (!select) {
        return;
    }

    for (let option of select.options) {
        const originalText = option.textContent;
        option.textContent = transformFunction(originalText);
        // Сохраняем полное ФИО в title для подсказки при наведении
        option.title = originalText;
    }
}

// Применяем преобразование ко всем опциям
applyToAllOptions('.right-column .wpcf7-form .doctors-select', convertNameFirstToSurnameInitials);

//Закрытие мобменю при скроле
document.addEventListener('DOMContentLoaded', function() {
  const offcanvas = document.getElementById('mobmenu');

  if (!offcanvas) {
    return;
  }

  const offcanvasInstance = bootstrap.Offcanvas.getOrCreateInstance(offcanvas);

  document.querySelector('.offcanvas-body').addEventListener('click', function(event) {
    const target = event.target;
    if (target.tagName === 'A' && target.getAttribute('href').startsWith('#')) {
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      } else {
        console.warn('Offcanvas instance not created');
      }
    }
  });
});

//кнопка прокрутки вверх
const scrollTopBtn = document.getElementById("scrollTopBtn");

window.addEventListener("scroll", () => {
if (window.scrollY > 300) {
    scrollTopBtn.classList.add("show");
} else {
    scrollTopBtn.classList.remove("show");
}
});

scrollTopBtn.addEventListener("click", () => {
window.scrollTo({
    top: 0,
    behavior: "smooth"
});
});